import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ChevronDown } from 'lucide-react';
import type { ReactNode } from 'react';

interface DetailPanelProps {
  label: string;
  /** Shown in the trigger so a collapsed panel still tells you how much is inside. */
  count?: number;
  defaultOpen?: boolean;
  children: ReactNode;
}

export const DetailPanel = ({ label, count, defaultOpen = false, children }: DetailPanelProps) => (
  <Collapsible defaultOpen={defaultOpen}>
    <CollapsibleTrigger className="flex items-center gap-1 text-muted-foreground text-sm">
      <ChevronDown className="h-4 w-4" />
      {count === undefined ? label : `${label} (${count} stafir)`}
    </CollapsibleTrigger>
    <CollapsibleContent>{children}</CollapsibleContent>
  </Collapsible>
);

export const TextPanel = ({ label, body, defaultOpen }: { label: string; body: string; defaultOpen?: boolean }) => (
  <DetailPanel label={label} count={body.length} defaultOpen={defaultOpen}>
    <pre className="mt-2 max-h-72 overflow-auto whitespace-pre-wrap rounded-md border p-3 text-xs">{body}</pre>
  </DetailPanel>
);
